import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiChevronRight } from "react-icons/bi";
import { Link } from 'react-router-dom';

const Breadcrumb = ({ page, name, link }) => {
    const { t } = useTranslation();

    return (
        <div className='md:px-5 py-4'>
            <div className="flex" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1">
                    <li className="inline-flex items-center">
                        <Link to="/" className="hover:no-underline ml-1 cursor-pointer text-xs font-poppins font-normal text-gray-500 md:ml-2 hover:text-bnd-1">
                            {t('home.nav.home')}
                        </Link>
                    </li>
                    {page &&
                        <li>
                            {link === true ?
                                <Link to="/user" className="flex items-center hover:no-underline ml-1 cursor-pointer text-xs font-poppins font-normal text-gray-500 md:ml-2 hover:text-bnd-1">

                                    <BiChevronRight className='mr-1 text-gray-900' />
                                    <span className='hover:no-underline ml-1 cursor-pointer text-xs font-poppins font-normal md:ml-2 text-bnd-1'>{page && page}</span>

                                </Link>
                                :
                                <div className="flex items-center">
                                    <BiChevronRight className='mr-1 text-gray-900' />
                                    <span className='hover:no-underline ml-1 cursor-pointer text-xs font-poppins font-normal md:ml-2 text-bnd-1'>{page && page}</span>
                                </div>
                            }
                        </li>
                    }
                    {name &&
                        <li aria-current="page">
                            <div className="flex items-center">
                                <BiChevronRight className='mr-1 text-gray-900' />
                                <span className="ml-1 text-xs font-poppins font-normal md:ml-2 text-bnd-1">{name && name.length > 32 ? name.substring(32, 0) + ".." : name}</span>
                            </div>
                        </li>
                    }
                </ol>
            </div>
        </div>
    );
};

export default Breadcrumb;